import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  partnerProfile: null,
  partnerProfileLoadStatus: 'idle',
  tokens: {
    id_token: null,
    access_token: null,
    refresh_token: null,
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload.user;
      state.tokens = {
        id_token: action.payload.id_token,
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
      };
    },
    setPartnerProfile(state, action) {
      state.partnerProfile = action.payload;
      state.partnerProfileLoadStatus = 'loaded';
    },
    setPartnerProfileLoading(state) {
      state.partnerProfile = null;
      state.partnerProfileLoadStatus = 'loading';
    },
    setPartnerProfileError(state) {
      state.partnerProfile = null;
      state.partnerProfileLoadStatus = 'error';
    },
    clearPartnerProfile(state) {
      state.partnerProfile = null;
      state.partnerProfileLoadStatus = 'idle';
    },
    clearUser(state) {
      state.user = null;
      state.partnerProfile = null;
      state.partnerProfileLoadStatus = 'idle';
      state.tokens = {
        id_token: null,
        access_token: null,
        refresh_token: null,
      };
    },
  },
});

export const {
  setUser,
  setPartnerProfile,
  setPartnerProfileLoading,
  setPartnerProfileError,
  clearPartnerProfile,
  clearUser,
} = authSlice.actions;
export default authSlice.reducer;
